import apiClient from '../utils/axiosClient';

const loadCurrentStore = async (storeId?: string) => {
  return (await apiClient.get('/settings', {
    params: {
      storeId,
    },
  }))?.data;
};

const updateStore = async (data: any) => {
  return (await apiClient.put('/settings', data))?.data;
};

const loadCurrentStoreSettingsSetup = async () => {
  return (await apiClient.get('/settings/setup'))?.data;
};

export {
  loadCurrentStore,
  updateStore,
  loadCurrentStoreSettingsSetup,
}
